/* RTT header — toggle solid state on scroll (homepage only) */
(function () {
  var header = document.querySelector('.template-index .header');
  if (!header) return;
  function onScroll() { header.classList.toggle('rtt-head-solid', window.scrollY > 60); }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('load', onScroll);
  window.addEventListener('hashchange', onScroll);
  onScroll();
  // Deep-link / post-submit loads (e.g. ?contact_posted=true#rtt-quote-form):
  // the browser jumps to the #hash AFTER this script runs, so the page is
  // scrolled but no scroll event fires. Re-check shortly after load so the
  // header goes solid/fixed instead of sitting absolute and out of view.
  setTimeout(onScroll, 250);
})();
